"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./NearBenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/men.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "A team in just 2 weeks",
      description: "Accelerate your development process by up to 70% by saving recruitment, onboarding, and team management time.",
    },
    {
      iconSrc: "/scale.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Plan Costs Icon",
      title: "Scale up or down as needed",
      description: "Increase flexibility and speed of delivery by adjusting your team structure, size, and capabilities to your project requirements.",
    },
    {
      iconSrc: "/eu.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "EU-based",
      description: "Ensure seamless collaboration, effective communication, and flawless cultural fit with a team based in Europe.",
    },
    {
      iconSrc: "/experts.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "A pool of digital product experts",
      description:
        "Have access to an extensive skill set of Developers, Designers, Data Scientists, Project Managers, and Designers who have built industry-leading digital products.",
    },
     {
      iconSrc: "/build.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "Seasoned professionals",
      description:
        "80% of companies report improved delivery quality and productivity when outsourcing to highly experienced teams like ours. Our vertical expertise further strengthens clients' digital strategies and competitive edge.",
    },
     {
      iconSrc: "/calci.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "No HR bureaucracy or cost",
      description:
        "Reduce recruitment costs by up to 50%, eliminating the need for extensive HR bureaucracy on hiring, training, and benefits administration.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title1453 animate-left" ref={headerRef}>
            WHAT YOU GAIN FROM
            
            <span className="scoping-benefits-highlight"> NEARSHORE TEAMS</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
           Experience the power of nearshore teams to speed up your company's processes.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
